<!-- <p>pharmacy-billing works!</p>
<h2>pharmacy-billing Running</h2> -->
<div style="padding: 20px;">
  <div style="display: flex; width: 100%; margin-top: 0px;  height: 100vh; ">

    <div style="margin-left: 18px ;display: flex; justify-content: flex-start; width: 60vw; flex-direction: column;">

      <div class="heading">Pharmacy</div>
      <!-- <div class="subheading">This feature is used to prepare quotation for patient medicines.</div> -->

      <div style="height: 88vh; width: 100%;">
        <div style="height: 80vh; width: 100%;">


          <table mat-table [dataSource]="medicineQuotationArr" class="quotation-table mat-elevation-z2">

            <!-- Sr No -->
            <ng-container matColumnDef="srNo">
              <th mat-header-cell *matHeaderCellDef> Sr No </th>
              <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
            </ng-container>

            <!-- Medicines -->
            <ng-container matColumnDef="medicines">
              <th mat-header-cell *matHeaderCellDef> Medicines </th>
              <td mat-cell *matCellDef="let element" style="text-align: left;"> {{ element.Drug.product_name }} </td>
            </ng-container>

            <!-- Prescribed -->
            <!-- <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef> Prescribed </th>
              <td mat-cell *matCellDef="let element"> {{ element.quantity }} </td>
            </ng-container> -->

            <!-- Packaging -->
            <ng-container matColumnDef="packaging">
              <th mat-header-cell *matHeaderCellDef> Quantity </th>
              <td mat-cell *matCellDef="let element">
                <input type="text" class="table-input" [(ngModel)]="element.packaging"
                  (keypress)="allowOnlyNumbers($event)" (blur)="onPackagingBlur(element)" />
              </td>
            </ng-container>


            <!-- Batch No -->
            <ng-container matColumnDef="batchNo">
              <th mat-header-cell *matHeaderCellDef> Batch No </th>
              <td mat-cell *matCellDef="let element">
                <input type="text" class="table-input" [(ngModel)]="element.batchNo" placeholder="Batch No" />
              </td>
            </ng-container>

            <!-- Expiry Date -->
            <ng-container matColumnDef="expiryDate">
              <th mat-header-cell *matHeaderCellDef> Expiry Date </th>
              <td mat-cell *matCellDef="let element">
                <input matInput [matDatepicker]="picker" class="table-input" [(ngModel)]="element.expiryDate"
                  placeholder="Exp. Date" (focus)="picker.open()" (keydown)="$event.preventDefault()" />
                <mat-datepicker #picker></mat-datepicker>
              </td>
            </ng-container>

            <!-- MRP -->
            <ng-container matColumnDef="mrp">
              <th mat-header-cell *matHeaderCellDef> MRP </th>
              <td mat-cell *matCellDef="let element">

                <input type="text" (keypress)="validateMRPInput($event, element)" class="table-input"
                  [(ngModel)]="element.mrp"
                  (input)="limitMRP($event, element); updateCalculations(element);sanitizeMRP($event, element);" />
              </td>
            </ng-container>

            <!-- SGST -->
            <ng-container matColumnDef="sgst">
              <th mat-header-cell *matHeaderCellDef> SGST (2.5%) </th>
              <td mat-cell *matCellDef="let element"> Rs.{{ element.sgst | number:'1.2-2' }} </td>
            </ng-container>

            <!-- CGST -->
            <ng-container matColumnDef="cgst">
              <th mat-header-cell *matHeaderCellDef> CGST (2.5%) </th>
              <td mat-cell *matCellDef="let element"> Rs.{{ element.cgst | number:'1.2-2' }} </td>
            </ng-container>

            <!-- Total Amount -->
            <ng-container matColumnDef="totalAmount">
              <th mat-header-cell *matHeaderCellDef> Total Amount </th>
              <td mat-cell *matCellDef="let element"> Rs.{{ element.totalAmount | number:'1.2-2' }} </td>
            </ng-container>

            <!-- Header & Rows -->
            <tr mat-header-row
              *matHeaderRowDef="['srNo','medicines','packaging','batchNo','expiryDate','mrp','sgst','cgst','totalAmount']; sticky:true">
            </tr>
            <tr mat-row
              *matRowDef="let row; columns: ['srNo','medicines','packaging','batchNo','expiryDate','mrp','sgst','cgst','totalAmount'];">
            </tr>
          </table>



        </div>
      </div>
    </div>

    <!-- Right Side Quotation Summary -->
    <div
      style="display: flex; width: 45vw; height: 100vh; flex-direction: row; justify-content: center; margin-top: 16px;">
      <div
        style="height: fit-content; width: 81%; background-color: #fff; border-color: rgb(70, 135, 191); border-style: solid; border-radius: 20px; border-width: 1px; padding: 15px;">

        <div style="display: flex; justify-content: space-between;">
          <div style="margin: 0px 0px 16px 0px; font-size: 24px; color: #333; font-weight: bold;">
            Quotation Summary
          </div>
        </div>

        <!-- Total Medicines -->
        <div style="width: 100%; display: flex; justify-content: space-between; font-size: 16px; margin: 8px 0;">
          <div>Total Medicines</div>
          <div>{{ medicineQuotationArr.length }}</div>
        </div>

        <!-- Total Amount -->
        <div style="width: 100%; display: flex; justify-content: space-between; font-size: 16px; margin: 8px 0;">
          <div>Total Amount</div>
          <div>Rs. {{ totalQuotationAmount | number:'1.2-2' }}</div>
        </div>

        <!-- Button aligned inside card -->
        <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
          <button (click)="previewQuotation()" class="createReceipt">Preview Quotation</button>
        </div>

      </div>
    </div>

  </div>

</div>
<ng-template #quotationPreviewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Quotation Preview</h5>
    <button mat-icon-button mat-dialog-close aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>

  </div>

  <div class="modal-body">
    <iframe [src]="quotationPdfUrl" width="100%" [style.height.px]="iframeHeight" style="border:none;"></iframe>

  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
    <button class="btn btn-primary" (click)="downloadQuotation()">Download</button>
  </div>
</ng-template>
<p-toast></p-toast>